<template>

  <div v-if="!hasPermission('List Record Professional')">Você não tem permissão para acessar esta página!</div>

  <div v-else>
    <Toolbar>
      <template #actions>
        <button
          class="btn btn-sm btn-light-primary"
          type="button"
          data-bs-toggle="modal"
          v-if="hasPermission('Store Record Professional')"
          title="Criar tipo do local"
          data-bs-target="#modal_store_place_rectype"
          @click="resetPlaceRectypeForm()"
        >
          <i class="bi bi-building me-1"></i> Novo tipo
        </button>
      </template>
    </Toolbar>
    <div class="container-xxl">
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                    fill="black"></path>
              </svg>
            </span>
              <input type="text" data-kt-user-table-filter="search" v-model="search"
                     class="form-control form-control-solid w-250px ps-14"
                     placeholder="Pesquisar ...">
            </div>
          </div>
          <div class="card-toolbar">
            <div class="col-md-6" v-show="professionals.length > 1">
              <select class="form-select form-control-solid" aria-label="Selecionar Profissional"
                      v-model="currentProfessionalId" @change="loadRectypes($event.target.value)">
                <option value="" disabled selected v-if="professionals.length > 1">--Selecione--</option>
                <option :value="professional.id_prof" v-for="professional in professionals">
                  {{ professional.prof_name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <button class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                      v-if="hasPermission('Store Record Professional')"
                      title="Novo Tipo de Registro" data-bs-target="#modal_store_rectype"
                      @click="searchRectype='';formStore.id_rectype='';formStore.id_record_attr_template='';availableTemplates=[]">
                <i class="bi bi-plus-lg"></i> Adicionar
              </button>
            </div>
          </div>
        </div> <!-- card header -->

        <div class="card-body py-4">
          <table class="table table-row-bordered gy-5">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Tipo de Registro</th>
              <th style="text-align: center">Ativo</th>
              <th style="text-align: center">Ações</th>
            </tr>
            </thead>
            <tbody v-for="rectype in rectypesFiltered" :key="rectype.id_rectype">
            <tr>
              <td>{{ rectype.rectype_name }}</td>
              <td style="text-align: center">
                <span class="badge badge-light-success" v-if="rectype.active">Sim</span>
                <span class="badge badge-light-danger" v-else>Não</span>
              </td>
              <td style="text-align: center">
                <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#modal_edit_rectype"
                        v-if="hasPermission('Update Record Professional')"
                        @click="onClickBtnEdit(rectype)"
                        title="Editar">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        title="Ver detalhes"
                        rel="tooltip"
                        v-if="hasPermission('List Record Professional Attribute')"
                        @click="getAttributes(rectype.id_rectype);">
                  <i class="bi bi-eye"></i>
                </button>
                <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        v-if="hasPermission('Delete Record Professional')"
                        @click="deleteRectype(rectype.id_rectype)"
                        data-bs-toggle="tooltip" title="Excluir Tipo de registro">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!attributesHide  && currentRectypeId === rectype.id_rectype && !loading">
              <td colspan="3">
                <div class="d-flex justify-content-end gap-2">
                  <button class="btn btn-light-info me-1" data-bs-toggle="modal"
                          title="Aplicar template" data-bs-target="#modal_apply_template"
                          v-if="hasPermission('Store Record Professional Attribute')"
                          @click="loadTemplatesForRectype(rectype.id_rectype); formApplyTemplate.id_record_attr_template=''">
                    <i class="bi bi-layout-text-window-reverse"></i> Aplicar template
                  </button>
                  <button class="btn btn-light-primary me-3" data-bs-toggle="modal"
                          title="Novo Atributo" data-bs-target="#modal_store_attribute"
                          v-if="hasPermission('Store Record Professional Attribute')"
                          @click="clearAttrOptionStore(); clearAttrOptionEdit(); formStoreAttribute.active=true;">
                    <i class="bi bi-plus-lg"></i> Novo Atributo
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="!attributesHide  && (attributes.length) && currentRectypeId === rectype.id_rectype && !loading">
              <td colspan="3">
                <table class="table table-row-bordered table-hover table-light gy-3">
                  <thead>
                  <tr class="fw-bold fs-6 text-muted">
                    <th></th>
                    <th style="text-align: center">#</th>
                    <th>Atributo</th>
                    <th>Tipo</th>
                    <th style="text-align: center">Ativo</th>
                    <th style="text-align: center">Açoes</th>
                  </tr>
                  </thead>
                  <draggable v-model="attributes" :disabled="draging" tag="tbody" item-key="id_rectype_attr"
                             @change="onChangeAttributeOrder();">
                    <template #item="{ element, index }">
                      <tr class="hover-row">
                        <td style="text-align: center; width: 50px">
                          <i class="h1 bi bi-grip-vertical"></i>
                        </td>
                        <td style="text-align: center">
                          {{ index + 1 }}
                        </td>
                        <td>{{ element.label }}</td>
                        <td>
                          <span class="badge badge-light-primary">{{ attributeTypeLabel(element.type) }}</span>
                        </td>
                        <td style="text-align: center">
                          <span class="badge badge-light-success" v-if="element.active">Sim</span>
                          <span class="badge badge-light-danger" v-else>Não</span>
                        </td>
                        <td style="text-align: center">
                          <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#modal_edit_attribute"
                                  v-if="hasPermission('Update Record Professional Attribute')"
                                  @click="onClickBtnEditAttribute(element)"
                                  title="Editar">
                            <i class="bi bi-pencil-square"></i>
                          </button>
                          <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                  v-if="hasPermission('Delete Record Professional Attribute')"
                                  @click="deleteAttribute(element.id_rectype_attr)"
                                  data-bs-toggle="tooltip" title="Excluir Atributo">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </template>
                  </draggable>
                </table>
              </td>
            </tr> <!-- attribute table -->
            </tbody>
          </table>
        </div> <!-- card body -->
      </div> <!-- card -->

      <div class="modal fade" tabindex="-1" id="modal_store_rectype">
        <div class="modal-dialog modal-lg">
          <form method="post" @submit.prevent="submitFormStore">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Adicionar Tipo de Registro</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                     aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <div class="col-md-12 mb-6 mt-4">
                  <label for="id_rectype_store" class="required form-label">Selecione o Tipo de registro</label>
                  <select class="form-control form-select" id="id_rectype_store"
                          aria-label="Selecione o tipo de registro" v-model="formStore.id_rectype"
                          @change="onStoreRectypeChange"
                          autofocus required>
                    <option value="" disabled selected>--Selecione--</option>
                    <option :value="rectype.id_rectype" v-for="rectype in allRectypes" :key="rectype.id_rectype">
                      {{ rectype.rectype_name }}{{ rectype.id_place ? ' (local)' : '' }}
                    </option>
                  </select>
                  <small class="text-danger" v-if="formStoreErrors.rectype_name">{{
                      formStoreErrors.rectype_name[0]
                    }}</small>
                </div>
                <div class="col-md-12 mb-6" v-if="availableTemplates.length">
                  <label for="id_template_store" class="form-label">Template de atributos</label>
                  <select class="form-control form-select" id="id_template_store"
                          v-model="formStore.id_record_attr_template">
                    <option value="">Padrão do tipo</option>
                    <option
                      v-for="template in availableTemplates"
                      :key="template.id_record_attr_template"
                      :value="template.id_record_attr_template"
                    >
                      {{ template.template_name }}{{ template.is_default ? ' (padrão)' : '' }}
                    </option>
                  </select>
                  <div class="form-text" v-if="selectedStoreTemplateDescription">
                    {{ selectedStoreTemplateDescription }}
                  </div>
                </div>
                <div class="col-md-12 mt-6">
                  <label for="rectype_active_store" class="required form-label">Ativo?</label>
                  <input class="form-check-input" type="checkbox" v-model="formStore.active" id="rectype_active_store"
                         checked>
                  <small class="text-danger" v-if="formStoreErrors.active">{{ formStoreErrors.active[0] }}</small>
                </div>
                <div class="col-md-12 mt-6">
                  <label for="rectype_auto_include_store" class="required form-label">Incluir automaticamente ao iniciar
                    atendimento?</label>
                  <input class="form-check-input" type="checkbox" v-model="formStore.auto_include"
                         id="rectype_auto_include_store" checked>
                  <small class="text-danger" v-if="formStoreErrors.auto_include">{{
                      formStoreErrors.auto_include[0]
                    }}</small>
                </div>
                <div class="col-md-12 mt-6">
                  <label for="rectype_use_specialty_panel_store" class="form-label">Usar painel da especialidade?</label>
                  <input class="form-check-input" type="checkbox" v-model="formStore.use_specialty_panel"
                         id="rectype_use_specialty_panel_store">
                  <small class="text-danger" v-if="formStoreErrors.use_specialty_panel">{{
                      formStoreErrors.use_specialty_panel[0]
                    }}</small>
                </div>
                <div class="col-md-12 mt-6">
                  <label class="form-label fw-bold">Assistente de IA</label>
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" v-model="formStore.ai_assistant_enabled" id="ai_assistant_enabled_store">
                    <label class="form-check-label" for="ai_assistant_enabled_store">Habilitar assistente de IA</label>
                  </div>
                  <div class="ms-4" v-if="formStore.ai_assistant_enabled">
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="checkbox" v-model="formStore.ai_summary_enabled" id="ai_summary_enabled_store">
                      <label class="form-check-label" for="ai_summary_enabled_store">Resumo do histórico</label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="checkbox" v-model="formStore.ai_transcription_enabled" id="ai_transcription_enabled_store">
                      <label class="form-check-label" for="ai_transcription_enabled_store">Transcrição da consulta</label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="checkbox" v-model="formStore.ai_prescription_validation_enabled" id="ai_prescription_validation_enabled_store">
                      <label class="form-check-label" for="ai_prescription_validation_enabled_store">Validação de prescrição</label>
                    </div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="checkbox" v-model="formStore.ai_prescription_chat_enabled" id="ai_prescription_chat_enabled_store">
                      <label class="form-check-label" for="ai_prescription_chat_enabled_store">Consulta sobre medicamentos</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Cadastrar</button>
              </div>
            </div>
          </form>
        </div>
      </div> <!-- modal_store_rectype -->

      <div class="modal fade" tabindex="-1" id="modal_edit_rectype">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
          <form method="post" @submit.prevent="submitFormEdit">
            <div class="modal-content">
              <div class="modal-header">
                <div>
                  <h5 class="modal-title mb-0">Editar tipo de registro</h5>
                  <div class="text-muted fs-7 mt-1" v-if="formEdit.rectype_name">
                    {{ formEdit.rectype_name }}
                  </div>
                </div>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                     aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <div class="alert alert-light border mb-5" v-if="!canEditTypeDefinition">
                  <div class="fw-semibold mb-1">Tipo de sistema</div>
                  <div class="fs-7 text-muted mb-0">
                    Nome e recursos liberados (documentos, CID, receita…) são definidos pelo sistema.
                    Você ainda pode ajustar uso no profissional e o assistente de IA.
                  </div>
                </div>

                <div class="mb-6">
                  <div class="fs-7 text-uppercase text-muted fw-bold mb-3">Identificação</div>
                  <label for="rectype_name_edit" class="form-label required">Nome</label>
                  <input class="form-control form-control-solid"
                         :disabled="!canEditTypeDefinition"
                         v-model="formEdit.rectype_name"
                         id="rectype_name_edit"
                         minlength="3"
                         maxlength="100"
                         placeholder="Ex.: Sessão terapêutica">
                  <small class="text-danger" v-if="formEditErrors.rectype_name">{{
                      formEditErrors.rectype_name[0]
                    }}</small>
                </div>

                <div class="separator separator-dashed mb-6"></div>

                <div class="mb-6">
                  <div class="fs-7 text-uppercase text-muted fw-bold mb-3">Uso neste profissional</div>
                  <div class="row g-4">
                    <div class="col-md-4">
                      <div class="border rounded p-4 h-100 bg-light">
                        <div class="d-flex justify-content-between align-items-start gap-3">
                          <div>
                            <div class="fw-semibold">Ativo</div>
                            <div class="text-muted fs-8">Disponível na lista do profissional</div>
                          </div>
                          <div class="form-check form-switch form-check-custom form-check-solid m-0">
                            <input class="form-check-input" type="checkbox" role="switch"
                                   v-model="formEdit.active" id="rectype_active_edit">
                          </div>
                        </div>
                        <small class="text-danger" v-if="formEditErrors.active">{{ formEditErrors.active[0] }}</small>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="border rounded p-4 h-100 bg-light">
                        <div class="d-flex justify-content-between align-items-start gap-3">
                          <div>
                            <div class="fw-semibold">Incluir no atendimento</div>
                            <div class="text-muted fs-8">Abre automaticamente ao iniciar</div>
                          </div>
                          <div class="form-check form-switch form-check-custom form-check-solid m-0">
                            <input class="form-check-input" type="checkbox" role="switch"
                                   v-model="formEdit.auto_include" id="rectype_auto_include_edit">
                          </div>
                        </div>
                        <small class="text-danger" v-if="formEditErrors.auto_include">{{
                            formEditErrors.auto_include[0]
                          }}</small>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="border rounded p-4 h-100 bg-light">
                        <div class="d-flex justify-content-between align-items-start gap-3">
                          <div>
                            <div class="fw-semibold">Painel da especialidade</div>
                            <div class="text-muted fs-8">Odonto, oftalmo e similares</div>
                          </div>
                          <div class="form-check form-switch form-check-custom form-check-solid m-0">
                            <input class="form-check-input" type="checkbox" role="switch"
                                   v-model="formEdit.use_specialty_panel" id="rectype_use_specialty_panel_edit">
                          </div>
                        </div>
                        <small class="text-danger" v-if="formEditErrors.use_specialty_panel">{{
                            formEditErrors.use_specialty_panel[0]
                          }}</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="separator separator-dashed mb-6"></div>

                <div class="mb-6" v-if="canEditTypeDefinition || hasTypeAllowFlags">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="fs-7 text-uppercase text-muted fw-bold">Recursos liberados</div>
                    <span class="badge badge-light" v-if="!canEditTypeDefinition">Somente leitura</span>
                  </div>
                  <div class="row g-3">
                    <div class="col-sm-6">
                      <label class="border rounded p-3 d-flex align-items-start gap-3 h-100 mb-0"
                             :class="canEditTypeDefinition ? 'cursor-pointer' : 'bg-light'"
                             for="edit_allow_document">
                        <input class="form-check-input mt-1" type="checkbox" v-model="formEdit.allow_document"
                               id="edit_allow_document" :disabled="!canEditTypeDefinition">
                        <span>
                          <span class="fw-semibold d-block">Documentos</span>
                          <span class="text-muted fs-8">Atestados, declarações e modelos</span>
                        </span>
                      </label>
                    </div>
                    <div class="col-sm-6">
                      <label class="border rounded p-3 d-flex align-items-start gap-3 h-100 mb-0"
                             :class="canEditTypeDefinition ? 'cursor-pointer' : 'bg-light'"
                             for="edit_allow_cid">
                        <input class="form-check-input mt-1" type="checkbox" v-model="formEdit.allow_cid"
                               id="edit_allow_cid" :disabled="!canEditTypeDefinition">
                        <span>
                          <span class="fw-semibold d-block">CID</span>
                          <span class="text-muted fs-8">Diagnósticos no atendimento</span>
                        </span>
                      </label>
                    </div>
                    <div class="col-sm-6">
                      <label class="border rounded p-3 d-flex align-items-start gap-3 h-100 mb-0"
                             :class="canEditTypeDefinition ? 'cursor-pointer' : 'bg-light'"
                             for="edit_allow_prescription">
                        <input class="form-check-input mt-1" type="checkbox" v-model="formEdit.allow_prescription"
                               id="edit_allow_prescription" :disabled="!canEditTypeDefinition">
                        <span>
                          <span class="fw-semibold d-block">Receita</span>
                          <span class="text-muted fs-8">Prescrições neste tipo</span>
                        </span>
                      </label>
                    </div>
                    <div class="col-sm-6">
                      <label class="border rounded p-3 d-flex align-items-start gap-3 h-100 mb-0"
                             :class="canEditTypeDefinition ? 'cursor-pointer' : 'bg-light'"
                             for="edit_allow_exam">
                        <input class="form-check-input mt-1" type="checkbox" v-model="formEdit.allow_exam_request"
                               id="edit_allow_exam" :disabled="!canEditTypeDefinition">
                        <span>
                          <span class="fw-semibold d-block">Pedido de exame</span>
                          <span class="text-muted fs-8">Solicitações neste tipo</span>
                        </span>
                      </label>
                    </div>
                    <div class="col-sm-6">
                      <label class="border rounded p-3 d-flex align-items-start gap-3 h-100 mb-0"
                             :class="canEditTypeDefinition ? 'cursor-pointer' : 'bg-light'"
                             for="edit_allow_programs">
                        <input class="form-check-input mt-1" type="checkbox" v-model="formEdit.allow_programs"
                               id="edit_allow_programs" :disabled="!canEditTypeDefinition">
                        <span>
                          <span class="fw-semibold d-block">Programas (ABA)</span>
                          <span class="text-muted fs-8">Coleta por tipo de medida (trial, frequência…)</span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="separator separator-dashed mb-6"></div>

                <div>
                  <div class="fs-7 text-uppercase text-muted fw-bold mb-3">Assistente de IA</div>
                  <div class="border rounded p-4">
                    <div class="d-flex justify-content-between align-items-start gap-3">
                      <div>
                        <div class="fw-semibold">Habilitar assistente</div>
                        <div class="text-muted fs-8">Libera os recursos abaixo neste tipo</div>
                      </div>
                      <div class="form-check form-switch form-check-custom form-check-solid m-0">
                        <input class="form-check-input" type="checkbox" role="switch"
                               v-model="formEdit.ai_assistant_enabled" id="ai_assistant_enabled_edit">
                      </div>
                    </div>

                    <div class="row g-3 mt-4" v-if="formEdit.ai_assistant_enabled">
                      <div class="col-sm-6">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" v-model="formEdit.ai_summary_enabled"
                                 id="ai_summary_enabled_edit">
                          <label class="form-check-label" for="ai_summary_enabled_edit">Resumo do histórico</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" v-model="formEdit.ai_transcription_enabled"
                                 id="ai_transcription_enabled_edit">
                          <label class="form-check-label" for="ai_transcription_enabled_edit">Transcrição da consulta</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox"
                                 v-model="formEdit.ai_prescription_validation_enabled"
                                 id="ai_prescription_validation_enabled_edit">
                          <label class="form-check-label" for="ai_prescription_validation_enabled_edit">
                            Validação de prescrição
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox"
                                 v-model="formEdit.ai_prescription_chat_enabled"
                                 id="ai_prescription_chat_enabled_edit">
                          <label class="form-check-label" for="ai_prescription_chat_enabled_edit">
                            Consulta sobre medicamentos
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
                <button type="submit" class="btn btn-primary">Salvar alterações</button>
              </div>
            </div>
          </form>
        </div>
      </div> <!-- modal_edit_rectype -->

      <div class="modal fade" tabindex="-1" id="modal_apply_template">
        <div class="modal-dialog">
          <form method="post" @submit.prevent="submitApplyTemplate">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Aplicar template de atributos</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <p class="text-muted">
                  Os atributos atuais deste tipo serão substituídos pelos campos do template selecionado.
                </p>
                <label class="required form-label">Template</label>
                <select class="form-control form-select" v-model="formApplyTemplate.id_record_attr_template" required>
                  <option value="" disabled>--Selecione--</option>
                  <option
                    v-for="template in availableTemplates"
                    :key="template.id_record_attr_template"
                    :value="template.id_record_attr_template"
                  >
                    {{ template.template_name }}{{ template.is_default ? ' (padrão)' : '' }}
                  </option>
                </select>
                <div class="form-text mt-2" v-if="selectedApplyTemplateDescription">
                  {{ selectedApplyTemplateDescription }}
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Aplicar</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="modal_store_place_rectype">
        <div class="modal-dialog">
          <form method="post" @submit.prevent="submitPlaceRectype">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Novo tipo de registro do local</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <div class="mb-5">
                  <label class="required form-label">Nome</label>
                  <input type="text" class="form-control form-control-solid"
                         v-model="formPlaceRectype.rectype_name" required minlength="3" maxlength="100"
                         placeholder="Ex.: Sessão terapêutica">
                </div>
                <div class="fs-7 text-uppercase text-muted fw-bold mb-3">Recursos liberados</div>
                <div class="row g-3">
                  <div class="col-12">
                    <label class="border rounded p-3 d-flex align-items-start gap-3 mb-0 cursor-pointer" for="place_allow_document">
                      <input class="form-check-input mt-1" type="checkbox" v-model="formPlaceRectype.allow_document" id="place_allow_document">
                      <span><span class="fw-semibold d-block">Documentos</span><span class="text-muted fs-8">Atestados e modelos</span></span>
                    </label>
                  </div>
                  <div class="col-12">
                    <label class="border rounded p-3 d-flex align-items-start gap-3 mb-0 cursor-pointer" for="place_allow_cid">
                      <input class="form-check-input mt-1" type="checkbox" v-model="formPlaceRectype.allow_cid" id="place_allow_cid">
                      <span><span class="fw-semibold d-block">CID</span><span class="text-muted fs-8">Diagnósticos</span></span>
                    </label>
                  </div>
                  <div class="col-12">
                    <label class="border rounded p-3 d-flex align-items-start gap-3 mb-0 cursor-pointer" for="place_allow_prescription">
                      <input class="form-check-input mt-1" type="checkbox" v-model="formPlaceRectype.allow_prescription" id="place_allow_prescription">
                      <span><span class="fw-semibold d-block">Receita</span><span class="text-muted fs-8">Prescrições</span></span>
                    </label>
                  </div>
                  <div class="col-12">
                    <label class="border rounded p-3 d-flex align-items-start gap-3 mb-0 cursor-pointer" for="place_allow_exam">
                      <input class="form-check-input mt-1" type="checkbox" v-model="formPlaceRectype.allow_exam_request" id="place_allow_exam">
                      <span><span class="fw-semibold d-block">Pedido de exame</span><span class="text-muted fs-8">Solicitações</span></span>
                    </label>
                  </div>
                  <div class="col-12">
                    <label class="border rounded p-3 d-flex align-items-start gap-3 mb-0 cursor-pointer" for="place_allow_programs">
                      <input class="form-check-input mt-1" type="checkbox" v-model="formPlaceRectype.allow_programs" id="place_allow_programs">
                      <span><span class="fw-semibold d-block">Programas (ABA)</span><span class="text-muted fs-8">Coleta por tipo de medida (trial, frequência…)</span></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
                <button type="submit" class="btn btn-primary">Criar tipo</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="modal_store_attribute">
        <div class="modal-dialog modal-lg">
          <form method="post" @submit.prevent="submitFormStoreAttribute">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Adicionar atributo</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar"
                     @click="this.editingStoreOption = false;">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <div class="col-md-12 mb-6 mt-4">
                  <label for="id_rectype_attr_store" class="required form-label required">Atributo</label>
                  <input class="form-control form-control-solid"
                         v-model="formStoreAttribute.label" id="id_rectype_attr_store" autofocus="true" required>
                  <small class="text-danger" v-if="formStoreAttributeErrors.label">{{
                      formStoreAttributeErrors.label[0]
                    }}</small>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-6 mt-4">
                    <label for="type_store" class="required form-label required">Tipo de Atributo</label>
                    <select class="form-control form-select" id="type_store"
                            aria-label="Selecione o tipo do atributo" v-model="formStoreAttribute.type" required>
                      <option value="" disabled selected>--Selecione--</option>
                      <option :value="attributeType.id" v-for="attributeType in attributeTypes">
                        {{ attributeType.description }}
                      </option>
                    </select>
                    <small class="text-danger" v-if="formStoreAttributeErrors.type">{{
                        formStoreAttributeErrors.type[0]
                      }}</small>
                  </div>
                  <div class="col-md-6 mb-6 mt-4" v-if="formStoreAttribute.type === 'text' || formStoreAttribute.type === 'html'">
                    <label for="attr_text_rows_store" class="required form-label required">Número mínimo de linhas na tela</label>
                    <input class="form-control form-control-solid" type="number" min="1" max="20"
                           v-model="formStoreAttribute.text_rows"
                           id="attr_text_rows_store" required>
                    <small class="text-danger"
                           v-if="formStoreAttributeErrors.text_rows">{{ formStoreAttributeErrors.text_rows[0] }}</small>
                  </div>
                </div>
                <div class="col-md-12 mb-6" v-if="supportsDefaultText(formStoreAttribute.type)">
                  <label for="attr_default_text_store" class="form-label">Texto padrão</label>
                  <textarea v-if="formStoreAttribute.type === 'text'" class="form-control form-control-solid"
                            v-model="formStoreAttribute.default_text" id="attr_default_text_store"
                            :rows="formStoreAttribute.text_rows || 3"></textarea>
                  <QuillEditor v-else
                               :options="defaultTextEditorOptions"
                               class="attr-default-text-editor"
                               id="attr_default_text_store"
                               placeholder="Digite aqui..."
                               :value="formStoreAttribute.default_text || ''"
                               @change="onDefaultTextChange(formStoreAttribute, $event)"/>
                  <div class="form-text">{{ defaultTextHint(formStoreAttribute) }}</div>
                  <small class="text-danger"
                         v-if="formStoreAttributeErrors.default_text">{{ formStoreAttributeErrors.default_text[0] }}</small>
                </div>
                <div class="row">
                  <div class="col-md-6 mt-4">
                    <label for="attr_required_store" class="required form-label">Obrigatório?</label>
                    <input class="form-check-input" type="checkbox" v-model="formStoreAttribute.required"
                           id="attr_required_store" checked>
                    <small class="text-danger"
                           v-if="formStoreAttributeErrors.required">{{ formStoreAttributeErrors.required[0] }}</small>
                  </div>
                  <div class="col-md-6 mt-4">
                    <label for="attr_active_store" class="required form-label">Ativo?</label>
                    <input class="form-check-input" type="checkbox" v-model="formStoreAttribute.active"
                           id="attr_active_store" checked>
                    <small class="text-danger"
                           v-if="formStoreAttributeErrors.active">{{ formStoreAttributeErrors.active[0] }}</small>
                  </div>
                </div>
                <div v-if="supportsImportLastRecord(formStoreAttribute.type)" class="row">
                  <div class="col-md-6 mt-4">
                    <label for="attr_import_last_record_store" class="required form-label">Importar último registro?</label>
                    <input class="form-check-input" type="checkbox" v-model="formStoreAttribute.import_last_record"
                           id="attr_import_last_record_store" checked>
                    <small class="text-danger"
                           v-if="formStoreAttributeErrors.import_last_record">{{ formStoreAttributeErrors.import_last_record[0] }}</small>
                  </div>
                  <div v-if="false" class="col-md-6 mt-4">
                    <label for="attr_enable_file_import_store" class="required form-label">Permite importação de arquivo?</label>
                    <input class="form-check-input" type="checkbox" v-model="formStoreAttribute.enable_file_import"
                           id="attr_enable_file_import_store" checked>
                    <small class="text-danger"
                           v-if="formStoreAttributeErrors.enable_file_import">{{ formStoreAttributeErrors.enable_file_import[0] }}</small>
                  </div>
                </div>
                <div class="row" v-if="currentRectypeTranscriptionEnabled">
                  <div class="col-md-6 mt-4">
                    <label for="attr_filled_by_ai_store" class="required form-label">Preencher com IA?</label>
                    <input class="form-check-input" type="checkbox" v-model="formStoreAttribute.filled_by_ai"
                           id="attr_filled_by_ai_store" checked>
                    <small class="text-danger"
                           v-if="formStoreAttributeErrors.filled_by_ai">{{ formStoreAttributeErrors.filled_by_ai[0] }}</small>
                  </div>
                </div>
                <div v-if="false && formStoreAttribute.enable_file_import && formStoreAttribute.type === 'html'" class="col-md-12 mt-4">
                  <label for="attr_file_import_ai_prompt_store" class="form-label">Prompt para IA (opcional)</label>
                  <textarea class="form-control form-control-solid"
                            v-model="formStoreAttribute.file_import_ai_prompt"
                            id="attr_file_import_ai_prompt_store" rows="10"></textarea>
                   <small class="text-danger"
                         v-if="formStoreAttributeErrors.file_import_ai_prompt">{{ formStoreAttributeErrors.file_import_ai_prompt[0] }}</small>
                </div>
                <div class="card"
                     v-if="this.formStoreAttribute.type === 'radio' || this.formStoreAttribute.type === 'checkbox'">
                  <hr>
                  <h5 class="card-title mt-6">Opções</h5>
                  <div class="card-body">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-4">
                          <label for="attr_option_store_option" class="form-label">Opção</label>
                          <input ref="attrOptionsStoreOption" class="form-control form-control-solid" type="text"
                                 v-model="attr_option_store.option" id="attr_option_store_option" maxlength="200">
                        </div>
                        <div class="col-md-3 mt-6">
                          <label for="attr_option_store_require_compl" class="form-label">Possui complemento?</label>
                          <input class="form-check-input" type="checkbox" v-model="attr_option_store.require_compl"
                                 id="attr_option_store_require_compl">
                        </div>
                        <div class="col-md-3" v-if="attr_option_store.require_compl">
                          <label for="attr_option_store_label" class="form-label">Titulo</label>
                          <input class="form-control  form-control-solid" type="text" v-model="attr_option_store.label"
                                 id="attr_option_store_label">
                        </div>
                        <div class="col-md-2 mt-7">
                          <button v-if="!editingStoreOption && hasPermission('Update Record Professional Attribute')" type="button" class="btn btn-primary"
                                  @click="addStoreOption()">Incluir
                          </button>
                          <button v-if="editingStoreOption && hasPermission('Delete Record Professional Attribute')" type="button" class="btn btn-primary"
                                  @click="updStoreOption()">Alterar
                          </button>
                        </div>
                      </div>
                      <small class="text-danger"
                             v-if="formStoreAttributeErrors.options">{{ formStoreAttributeErrors.options[0] }}</small>
                      <div class="col-md-12 mb-6 mt-4">
                        <table class="table table-row-bordered table-hover table-light gy-3">
                          <thead>
                          <tr class="fw-bold fs-6 text-muted">
                            <th></th>
                            <th style="text-align: center">#</th>
                            <th>Opção</th>
                            <th style="text-align: center">Possui<br>complemento?</th>
                            <th style="text-align: center">TÍtulo do<br>complemento</th>
                            <th style="text-align: center">Opções</th>
                          </tr>
                          </thead>
                          <draggable v-model="this.formStoreAttribute.options" :disabled="draging || editingStoreOption"
                                     tag="tbody" item-key="option">
                            <template #item="{ element, index }">
                              <tr class="hover-row">
                                <td style="text-align: center; width: 10px">
                                  <i class="h1 bi bi-grip-vertical"></i>
                                </td>
                                <td style="text-align: center">{{ index + 1 }}</td>
                                <td style="word-wrap: break-word; max-width: 160px;">{{ element.option }}</td>
                                <td style="text-align: center">
                                  <span class="badge badge-light-success" v-if="element.require_compl">Sim</span>
                                  <span class="badge badge-light-danger" v-else>Não</span>
                                </td>
                                <td style="word-wrap: break-word; max-width: 100px;">{{ element.label }}</td>
                                <td style="text-align: center">
                                  <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                          data-bs-toggle="tooltip" title="Editar Opção" @click="edtStoreOption(index);">
                                    <i class="bi bi-pencil-square"></i>
                                  </button>
                                  <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                          data-bs-toggle="tooltip" title="Excluir Opção" @click="delStoreOption(index);">
                                    <i class="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                          </draggable>
                        </table>
                      </div>

                    </div>
                  </div>
                </div>
                <AttributeOptionsEditor
                    v-if="['grid', 'image_annotation', 'structured_list', 'odontogram'].includes(this.formStoreAttribute.type)"
                    v-model="formStoreAttribute.options"
                    :type="formStoreAttribute.type"
                    :grid-presets="gridPresets"
                    :image-assets="imageAssets"
                />
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Cadastrar</button>
              </div>
            </div>
          </form>
        </div>
      </div> <!-- modal_store_attribute -->

      <div class="modal fade" tabindex="-1" id="modal_edit_attribute">
        <div class="modal-dialog modal-lg">
          <form method="post" @submit.prevent="submitFormEditAttribute">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Editar atributo</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                     aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <div class="col-md-12 mb-6 mt-4">
                  <label for="id_rectype_attr_edit" class="required form-label required">Atributo</label>
                  <input class="form-control form-control-solid"
                         v-model="formEditAttribute.label" id="id_rectype_attr_edit" required>
                  <small class="text-danger" v-if="formEditAttributeErrors.label">{{
                      formEditAttributeErrors.label[0]
                    }}</small>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-6 mt-4">
                    <label for="type_edit" class="required form-label required">Tipo de Atributo</label>
                    <select class="form-control form-select" id="type_edit"
                            aria-label="Selecione o tipo do atributo" v-model="formEditAttribute.type" required>
                      <option :value="attributeType.id" v-for="attributeType in attributeTypes">
                        {{ attributeType.description }}
                      </option>
                    </select>
                    <small class="text-danger" v-if="formEditAttributeErrors.type">{{
                        formEditAttributeErrors.type[0]
                      }}</small>
                  </div>
                  <div class="col-md-6 mb-6 mt-4" v-if="formEditAttribute.type === 'text' || formEditAttribute.type === 'html'">
                    <label for="attr_text_rows_edit" class="required form-label required">Número mínimo de linhas na tela</label>
                    <input class="form-control form-control-solid" type="number" min="1" max="20"
                           v-model="formEditAttribute.text_rows"
                           id="attr_text_rows_edit" required>
                    <small class="text-danger"
                           v-if="formEditAttributeErrors.text_rows">{{ formEditAttributeErrors.text_rows[0] }}</small>
                  </div>
                </div>
                <div class="col-md-12 mb-6" v-if="supportsDefaultText(formEditAttribute.type)">
                  <label for="attr_default_text_edit" class="form-label">Texto padrão</label>
                  <textarea v-if="formEditAttribute.type === 'text'" class="form-control form-control-solid"
                            v-model="formEditAttribute.default_text" id="attr_default_text_edit"
                            :rows="formEditAttribute.text_rows || 3"></textarea>
                  <QuillEditor v-else
                               :options="defaultTextEditorOptions"
                               class="attr-default-text-editor"
                               id="attr_default_text_edit"
                               placeholder="Digite aqui..."
                               :value="formEditAttribute.default_text || ''"
                               @change="onDefaultTextChange(formEditAttribute, $event)"/>
                  <div class="form-text">{{ defaultTextHint(formEditAttribute) }}</div>
                  <small class="text-danger"
                         v-if="formEditAttributeErrors.default_text">{{ formEditAttributeErrors.default_text[0] }}</small>
                </div>
                <div class="row">
                  <div class="col-md-6 mt-2">
                    <label for="attr_required_edit" class="required form-label required">Obrigatório?</label>
                    <input class="form-check-input" type="checkbox" v-model="formEditAttribute.required"
                           id="attr_required_edit" checked>
                    <small class="text-danger"
                           v-if="formEditAttributeErrors.required">{{ formEditAttributeErrors.required[0] }}</small>
                  </div>
                  <div class="col-md-6 mt-2">
                    <label for="attr_active_edit" class="required form-label required">Ativo?</label>
                    <input class="form-check-input" type="checkbox" v-model="formEditAttribute.active"
                           id="attr_active_edit" checked>
                    <small class="text-danger" v-if="formEditAttributeErrors.active">{{
                        formEditAttributeErrors.active[0]
                      }}</small>
                  </div>
                </div>
                <div v-if="supportsImportLastRecord(formEditAttribute.type)" class="row">
                  <div class="col-md-6 mt-4">
                    <label for="attr_import_last_record_edit" class="required form-label">Importar último registro?</label>
                    <input class="form-check-input" type="checkbox" v-model="formEditAttribute.import_last_record"
                           id="attr_import_last_record_edit" checked>
                    <small class="text-danger"
                           v-if="formEditAttributeErrors.import_last_record">{{ formEditAttributeErrors.import_last_record[0] }}</small>
                  </div>
                  <div v-if="false" class="col-md-6 mt-4">
                    <label for="attr_enable_file_import_edit" class="required form-label">Permite importação de arquivo?</label>
                    <input class="form-check-input" type="checkbox" v-model="formEditAttribute.enable_file_import"
                           id="attr_enable_file_import_edit" checked>
                    <small class="text-danger"
                           v-if="formEditAttributeErrors.enable_file_import">{{ formEditAttributeErrors.enable_file_import[0] }}</small>
                  </div>
                </div>
                <div class="row" v-if="currentRectypeTranscriptionEnabled">
                  <div class="col-md-6 mt-4">
                    <label for="attr_filled_by_ai_edit" class="required form-label">Preencher com IA?</label>
                    <input class="form-check-input" type="checkbox" v-model="formEditAttribute.filled_by_ai"
                           id="attr_filled_by_ai_edit" checked>
                    <small class="text-danger"
                           v-if="formEditAttributeErrors.filled_by_ai">{{ formEditAttributeErrors.filled_by_ai[0] }}</small>
                  </div>
                </div>
                <div v-if="false && formEditAttribute.enable_file_import && formEditAttribute.type === 'html'" class="col-md-12 mt-4">
                  <label for="attr_file_import_ai_prompt_edit" class="form-label">Prompt para IA (opcional)</label>
                  <textarea class="form-control form-control-solid"
                            v-model="formEditAttribute.file_import_ai_prompt"
                            id="attr_file_import_ai_prompt_edit" rows="10"></textarea>
                   <small class="text-danger"
                         v-if="formEditAttributeErrors.file_import_ai_prompt">{{ formEditAttributeErrors.file_import_ai_prompt[0] }}</small>
                </div>
                <div class="card"
                     v-if="this.formEditAttribute.type === 'radio' || this.formEditAttribute.type === 'checkbox'">
                  <hr>
                  <h5 class="card-title mt-2">Opções</h5>
                  <div class="card-body">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-4">
                          <label for="attr_option_edit_option" class="form-label">Opção</label>
                          <input ref="attrOptionsEditOption" class="form-control form-control-solid" type="text"
                                 v-model="attr_option_edit.option" id="attr_option_edit_option" maxlength="200">
                        </div>
                        <div class="col-md-3 mt-6">
                          <label for="attr_option_edit_require_compl" class="form-label">Possui complemento?</label>
                          <input class="form-check-input" type="checkbox" v-model="attr_option_edit.require_compl"
                                 id="attr_option_edit_require_compl">
                        </div>
                        <div class="col-md-3" v-if="attr_option_edit.require_compl">
                          <label for="attr_option_edit_label" class="form-label">Titulo</label>
                          <input class="form-control  form-control-solid" type="text" v-model="attr_option_edit.label"
                                 id="attr_option_edit_label">
                        </div>
                        <div class="col-md-2 mt-7">
                          <button v-if="!editingEditOption" type="button" class="btn btn-primary"
                                  @click="addEditOption()">Incluir
                          </button>
                          <button v-if="editingEditOption" type="button" class="btn btn-primary" @click="updEditOption()">
                            Alterar
                          </button>
                        </div>
                      </div>
                      <small class="text-danger"
                             v-if="formEditAttributeErrors.options">{{ formEditAttributeErrors.options[0] }}</small>
                      <div class="col-md-12 mb-6 mt-4">
                        <table class="table table-row-bordered table-hover table-light gy-3">
                          <thead>
                          <tr class="fw-bold fs-6 text-muted">
                            <th></th>
                            <th style="text-align: center">#</th>
                            <th>Opção</th>
                            <th style="text-align: center">Possui<br>complemento?</th>
                            <th style="text-align: center">TÍtulo do<br>complemento</th>
                            <th style="text-align: center">Opções</th>
                          </tr>
                          </thead>
                          <draggable v-model="this.formEditAttribute.options" :disabled="draging || editingEditOption"
                                     tag="tbody" item-key="option">
                            <template #item="{ element, index }">
                              <tr class="hover-row">
                                <td style="text-align: center; width: 10px">
                                  <i class="h1 bi bi-grip-vertical"></i>
                                </td>
                                <td style="text-align: center">{{ index + 1 }}</td>
                                <td style="word-wrap: break-word; max-width: 160px;">{{ element.option }}</td>
                                <td style="text-align: center">
                                  <span class="badge badge-light-success" v-if="element.require_compl">Sim</span>
                                  <span class="badge badge-light-danger" v-else>Não</span>
                                </td>
                                <td style="word-wrap: break-word; max-width: 100px;">{{ element.label }}</td>
                                <td style="text-align: center">
                                  <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                          data-bs-toggle="tooltip" title="Editar Opção" @click="edtEditOption(index);">
                                    <i class="bi bi-pencil-square"></i>
                                  </button>
                                  <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                          data-bs-toggle="tooltip" title="Excluir Opção" @click="delEditOption(index);">
                                    <i class="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            </template>
                          </draggable>
                        </table>
                      </div>

                    </div>
                  </div>
                </div>
                <AttributeOptionsEditor
                    v-if="['grid', 'image_annotation', 'structured_list', 'odontogram'].includes(this.formEditAttribute.type)"
                    v-model="formEditAttribute.options"
                    :type="formEditAttribute.type"
                    :grid-presets="gridPresets"
                    :image-assets="imageAssets"
                />


              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div> <!-- modal_edit_attribute -->

    </div>
  </div>

</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import draggable from 'vuedraggable'
import Permission from "../../helpers/permission";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import AttributeOptionsEditor from "./components/AttributeOptionsEditor.vue";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import QuillEditor from "vue-quill-editor/src/editor";

const IMPORT_LAST_RECORD_TYPES = ['text', 'html', 'number', 'checkbox', 'radio'];
const DEFAULT_TEXT_TYPES = ['text', 'html'];

export default {
  name: "RecordType",
  components: {
    draggable,
      Toolbar,
      AttributeOptionsEditor,
      QuillEditor,
  },
  data() {
    return {
      search: '',
      attributesHide: true,
      loading: false,
      draging: false,
      updatingAttribute: false,
      currentProfessionalId: '',
      currentRectypeId: '',
      rectypes: [],
      allRectypes: [],
      attributes: [],
      searchRectype: '',
      attributeTypes: [],
      gridPresets: {},
      imageAssets: [],
      formStore: {
        id_rectype: '',
        id_record_attr_template: '',
        active: true,
        auto_include: false,
        use_specialty_panel: false,
        ai_assistant_enabled: true,
        ai_summary_enabled: true,
        ai_transcription_enabled: true,
        ai_prescription_validation_enabled: true,
        ai_prescription_chat_enabled: true,
      },
      formStoreErrors: [],
      availableTemplates: [],
      formApplyTemplate: {
        id_record_attr_template: '',
      },
      formPlaceRectype: {
        rectype_name: '',
        allow_document: true,
        allow_cid: false,
        allow_prescription: false,
        allow_exam_request: false,
        allow_programs: false,
        active: true,
      },
      formEdit: {
        id_rectype: '',
        id_place: null,
        active: false,
        rectype_name: '',
        allow_document: false,
        allow_cid: false,
        allow_prescription: false,
        allow_exam_request: false,
        allow_programs: false,
        auto_include: false,
        use_specialty_panel: false,
        ai_assistant_enabled: true,
        ai_summary_enabled: true,
        ai_transcription_enabled: true,
        ai_prescription_validation_enabled: true,
        ai_prescription_chat_enabled: true,
      },
      formEditErrors: [],
      formStoreAttribute: {
        id_rectype_attr: '',
        id_prof: '',
        id_rectype: '',
        label: '',
        order: '',
        type: '',
        options: [],
        active: false,
        required: true,
        text_rows: 3,
        import_last_record: false,
        enable_file_import: false,
        file_import_ai_prompt: '',
        default_text: '',
        filled_by_ai: true,
      },
      attr_option_store: '',

      formStoreAttributeErrors: [],
      formEditAttribute: {
        id_rectype_attr: '',
        id_prof: '',
        id_rectype: '',
        label: '',
        order: '',
        type: '',
        options: [],
        active: false,
        required: true,
        text_rows: 3,
        import_last_record: false,
        enable_file_import: false,
        file_import_ai_prompt: '',
        default_text: '',
        filled_by_ai: true,
      },
      defaultTextEditorOptions: {
        modules: { toolbar: [['bold', 'italic'], [{ 'list': 'ordered' }, { 'list': 'bullet' }]] },
        theme: 'snow',
      },
      attr_option_edit: '',
      formEditAttributeErrors: [],
      editingStoreOption: false,
      indexStoreOption: false,
      editingEditOption: false,
      indexEditOption: false,
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    canEditTypeDefinition() {
      if (this.hasPermission('Update Record Type')) {
        return true;
      }
      const placeId = this.place?.id_place;
      const typePlaceId = this.formEdit.id_place;
      return !!placeId && !!typePlaceId && Number(placeId) === Number(typePlaceId);
    },
    hasTypeAllowFlags() {
      return this.formEdit.allow_document
        || this.formEdit.allow_cid
        || this.formEdit.allow_prescription
        || this.formEdit.allow_exam_request
        || this.formEdit.allow_programs;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
    rectypesFiltered() {
      return this.rectypes.filter(rectype => {
        return rectype.rectype_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    allRectypesFiltered() {
      return this.allRectypes.filter(rectype => {
        return rectype.rectype_name.toLowerCase().includes(this.searchRectype.toLowerCase());
      });
    },
    selectedStoreTemplateDescription() {
      const template = this.availableTemplates.find(
        (item) => String(item.id_record_attr_template) === String(this.formStore.id_record_attr_template),
      );
      return template?.template_description || '';
    },
    selectedApplyTemplateDescription() {
      const template = this.availableTemplates.find(
        (item) => String(item.id_record_attr_template) === String(this.formApplyTemplate.id_record_attr_template),
      );
      return template?.template_description || '';
    },
    currentRectypeTranscriptionEnabled() {
      const rectype = this.rectypes.find(
        (item) => String(item.id_rectype) === String(this.currentRectypeId),
      );

      return rectype?.ai_transcription_enabled === true;
    },
  },
  mounted() {
    if (this.professionals.length > 0) {
      this.currentProfessionalId = this.$store.state.auth.user.id_prof ?? this.professionals[0].id_prof;
      this.loadRectypes(this.currentProfessionalId);
    }
    this.loadAllRectypes();
    this.loadAttributeTypes();
    this.loadGridPresets();
    this.loadImageAssets();
    this.clearAttrOptionStore();
    this.clearAttrOptionEdit();
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    attributeTypeLabel(type) {
      const attributeType = this.attributeTypes.find((item) => item.id === type);
      return attributeType?.description ?? type;
    },
    loadAttributeTypes() {
      this.attributeTypes = [];
      http.get(`/record-types/attribute-types`).then((response) => {
        this.attributeTypes = response.data;
      });
    },
    loadGridPresets() {
      this.gridPresets = {};
      http.get(`/record-types/grid-presets`).then((response) => {
        this.gridPresets = response.data;
      });
    },
    loadImageAssets() {
      this.imageAssets = [];
      http.get(`/record-types/image-assets`).then((response) => {
        this.imageAssets = response.data;
      });
    },
    loadAllRectypes() {
      this.allRectypes = [];
      const params = this.place?.id_place ? { id_place: this.place.id_place } : {};
      http.get(`/record-types`, { params }).then((response) => {
        this.allRectypes = response.data;
      });
    },
    loadTemplatesForRectype(rectypeId) {
      this.availableTemplates = [];
      if (!rectypeId) return;
      const params = this.place?.id_place ? { id_place: this.place.id_place } : {};
      return http.get(`/record-types/${rectypeId}/attribute-templates`, { params }).then((response) => {
        this.availableTemplates = response.data || [];
        const defaultTemplate = this.availableTemplates.find((item) => item.is_default);
        if (defaultTemplate && !this.formStore.id_record_attr_template) {
          this.formStore.id_record_attr_template = defaultTemplate.id_record_attr_template;
        }
      });
    },
    onStoreRectypeChange() {
      this.formStore.id_record_attr_template = '';
      this.loadTemplatesForRectype(this.formStore.id_rectype);
    },
    resetPlaceRectypeForm() {
      this.formPlaceRectype = {
        rectype_name: '',
        allow_document: true,
        allow_cid: false,
        allow_prescription: false,
        allow_exam_request: false,
        allow_programs: false,
        active: true,
      };
    },
    submitPlaceRectype() {
      http.post(`/record-types`, {
        ...this.formPlaceRectype,
        id_place: this.place?.id_place,
      }).then(() => {
        this.loadAllRectypes();
        Alert.toastSuccess('Tipo de registro do local criado.');
        bootstrap.Modal.getInstance(document.getElementById('modal_store_place_rectype')).toggle();
      }).catch((e) => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? e);
      });
    },
    submitApplyTemplate() {
      Swal.fire({
        title: 'Aplicar template?',
        text: 'Os atributos atuais deste tipo serão substituídos.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, aplicar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-secondary',
        },
      }).then((result) => {
        if (!result.isConfirmed) return;
        http.post(
          `/professionals/${this.currentProfessionalId}/record-types/${this.currentRectypeId}/apply-template`,
          {
            id_record_attr_template: this.formApplyTemplate.id_record_attr_template,
            replace: true,
          },
        ).then(() => {
          this.getAttributes(this.currentRectypeId, false);
          Alert.toastSuccess('Template aplicado com sucesso.');
          bootstrap.Modal.getInstance(document.getElementById('modal_apply_template')).toggle();
        }).catch((e) => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data ?? e);
        });
      });
    },
    loadRectypes(professionalId) {
      this.rectypes = [];
      this.currentProfessionalId = professionalId;
      http.get(`/professionals/${professionalId}/record-types`).then((response) => {
        this.rectypes = response.data;
      });
    },
    submitFormStore() {
      this.formStoreErrors = [];
      http.post(`/professionals/${this.currentProfessionalId}/record-types`, this.formStore).then(_ => {
        this.loadRectypes(this.currentProfessionalId);
        Alert.toastSuccess("Tipo de registro cadastrado com sucesso.");
        this.formStore = {
          id_rectype: '',
          id_record_attr_template: '',
          active: true,
          auto_include: false,
          use_specialty_panel: false,
          ai_assistant_enabled: true,
          ai_summary_enabled: true,
          ai_transcription_enabled: true,
          ai_prescription_validation_enabled: true,
          ai_prescription_chat_enabled: true,
        };
        this.availableTemplates = [];
        bootstrap.Modal.getInstance(document.getElementById('modal_store_rectype')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formStoreErrors = e.response.data.errors;
        }
      });
    },
    onClickBtnEdit(rectype) {
      this.formEdit.id_rectype = rectype.id_rectype;
      this.formEdit.id_place = rectype.id_place ?? null;
      this.formEdit.active = rectype.active;
      this.formEdit.rectype_name = rectype.rectype_name;
      this.formEdit.allow_document = !!rectype.allow_document;
      this.formEdit.allow_cid = !!rectype.allow_cid;
      this.formEdit.allow_prescription = !!rectype.allow_prescription;
      this.formEdit.allow_exam_request = !!rectype.allow_exam_request;
      this.formEdit.allow_programs = !!rectype.allow_programs;
      this.formEdit.auto_include = rectype.auto_include;
      this.formEdit.use_specialty_panel = rectype.use_specialty_panel;
      this.formEdit.ai_assistant_enabled = rectype.ai_assistant_enabled !== false;
      this.formEdit.ai_summary_enabled = rectype.ai_summary_enabled !== false;
      this.formEdit.ai_transcription_enabled = rectype.ai_transcription_enabled !== false;
      this.formEdit.ai_prescription_validation_enabled = rectype.ai_prescription_validation_enabled !== false;
      this.formEdit.ai_prescription_chat_enabled = rectype.ai_prescription_chat_enabled !== false;
    },
    submitFormEdit() {
      const prof_rectype = {
        "id_rectype": this.formEdit.id_rectype,
        "active": this.formEdit.active,
        "auto_include": this.formEdit.auto_include,
        "use_specialty_panel": this.formEdit.use_specialty_panel,
        "ai_assistant_enabled": this.formEdit.ai_assistant_enabled,
        "ai_summary_enabled": this.formEdit.ai_summary_enabled,
        "ai_transcription_enabled": this.formEdit.ai_transcription_enabled,
        "ai_prescription_validation_enabled": this.formEdit.ai_prescription_validation_enabled,
        "ai_prescription_chat_enabled": this.formEdit.ai_prescription_chat_enabled,
      };
      this.formEditErrors = [];

      const savePivot = () => http.put(
        `/professionals/${this.currentProfessionalId}/record-types/${this.formEdit.id_rectype}`,
        prof_rectype,
      );

      const saveDefinition = () => {
        if (!this.canEditTypeDefinition) {
          return Promise.resolve();
        }

        return http.put(`/record-types/${this.formEdit.id_rectype}`, {
          rectype_name: this.formEdit.rectype_name,
          allow_document: this.formEdit.allow_document,
          allow_cid: this.formEdit.allow_cid,
          allow_prescription: this.formEdit.allow_prescription,
          allow_exam_request: this.formEdit.allow_exam_request,
          allow_programs: this.formEdit.allow_programs,
          id_place: this.place?.id_place,
        });
      };

      saveDefinition()
        .then(() => savePivot())
        .then(() => {
          this.loadRectypes(this.currentProfessionalId);
          this.loadAllRectypes();
          Alert.toastSuccess("Tipo de registro atualizado com sucesso.");
          bootstrap.Modal.getInstance(document.getElementById('modal_edit_rectype')).toggle();
        })
        .catch(e => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data ?? e);
          if (e.response?.data?.errors) {
            this.formEditErrors = e.response.data.errors;
          }
        });
    },
    onClickBtnEditAttribute(attribute) {
      this.formEditAttribute.id_rectype_attr = attribute.id_rectype_attr;
      this.formEditAttribute.id_prof = attribute.id_prof;
      this.formEditAttribute.id_rectype = attribute.id_rectype;
      this.formEditAttribute.label = attribute.label;
      this.formEditAttribute.order = attribute.order;
      this.formEditAttribute.type = attribute.type;
      this.formEditAttribute.options = attribute.options ?? [];
      this.formEditAttribute.active = attribute.active;
      this.formEditAttribute.required = attribute.required;
      this.formEditAttribute.text_rows = attribute.text_rows;
      this.formEditAttribute.import_last_record = attribute.import_last_record;
      this.formEditAttribute.filled_by_ai = attribute.filled_by_ai !== false;
      this.formEditAttribute.enable_file_import = attribute.enable_file_import;
      this.formEditAttribute.file_import_ai_prompt = attribute.file_import_ai_prompt;
      this.formEditAttribute.default_text = attribute.default_text ?? '';
      this.deletingEditOption = false;
    },
    supportsImportLastRecord(type) {
      return IMPORT_LAST_RECORD_TYPES.includes(type);
    },
    supportsDefaultText(type) {
      return DEFAULT_TEXT_TYPES.includes(type);
    },
    defaultTextHint(form) {
      if (this.supportsImportLastRecord(form.type) && form.import_last_record) {
        return 'Usado ao criar um novo prontuário quando o último registro não tiver valor para este atributo.';
      }
      return 'Preenchido automaticamente ao criar um novo prontuário.';
    },
    onDefaultTextChange(form, event) {
      if (typeof event?.html !== 'string') {
        return;
      }
      form.default_text = event.html;
    },
    attributePayload(form) {
      return {
        ...form,
        default_text: this.supportsDefaultText(form.type) ? (form.default_text || null) : null,
      };
    },
    submitFormStoreAttribute() {
      this.formStoreAttribute.id_prof = this.currentProfessionalId;
      this.formStoreAttribute.id_rectype = this.currentRectypeId;
      this.formStoreAttribute.order = this.attributes.length + 1;
      this.formStoreAttributeErrors = [];
      http.post(`/professionals/${this.currentProfessionalId}/record-types/${this.currentRectypeId}/attributes`, this.attributePayload(this.formStoreAttribute)).then(_ => {
        this.getAttributes(this.currentRectypeId, false);
        Alert.toastSuccess("Atributo cadastrado com sucesso.");
        this.formStoreAttribute = {
          id_rectype_attr: '',
          id_prof: '',
          id_rectype: '',
          label: '',
          order: '',
          active: true,
          required: true,
          options: [],
          text_rows: 3,
          import_last_record: false,
          enable_file_import: false,
          file_import_ai_prompt: '',
          default_text: '',
          filled_by_ai: true,
        };
        bootstrap.Modal.getInstance(document.getElementById('modal_store_attribute')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formStoreAttributeErrors = e.response.data.errors;
        }
      });
    },
    submitFormEditAttribute() {
      this.formEditAttributeErrors = [];
      http.put(`/professionals/${this.currentProfessionalId}/record-types/${this.currentRectypeId}/attributes/${this.formEditAttribute.id_rectype_attr}`, this.attributePayload(this.formEditAttribute)).then(() => {
        this.getAttributes(this.currentRectypeId, false);
        Alert.toastSuccess("Atributo atualizado com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_attribute')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formEditAttributeErrors = e.response.data.errors;
        }
      });
    },
    deleteRectype(rectypeId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o tipo de registro?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.currentProfessionalId}/record-types/${rectypeId}`).then(_ => {
            this.loadRectypes(this.currentProfessionalId);
            Alert.toastSuccess("Tipo de registro excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    deleteAttribute(rectypeAttrId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o atributo?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.currentProfessionalId}/record-types/${this.currentRectypeId}/attributes/${rectypeAttrId}`).then(_ => {
            this.getAttributes(this.currentRectypeId, false);
            Alert.toastSuccess("Atributo excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    getAttributes(rectypeId, switchAttributesHide = true) {
      if (!this.attributesHide && switchAttributesHide && this.currentRectypeId === rectypeId) {
        this.attributesHide = true;
        return;
      }
      this.loading = switchAttributesHide ? true : this.loading;
      this.currentRectypeId = rectypeId;
      http.get(`/professionals/${this.currentProfessionalId}/record-types/${rectypeId}/attributes`).then((response) => {
        this.attributes = response.data;
        this.loading = false;
        this.attributesHide = false;
      }).catch(e => {
        Alert.toastError(e.response.data);
        this.loading = false;
      });
    },
    onChangeAttributeOrder() {
      var updAttributes = [];
      this.draging = true;
      this.attributes.forEach(function (attribute, index) {
        if (attribute.order !== index + 1) {
          updAttributes.push({id_rectype_attr: attribute.id_rectype_attr, order: index + 1});
        }
      });
      if (updAttributes.length > 0) {
        http.put(`/professionals/${this.currentProfessionalId}/record-types/${this.currentRectypeId}/attributes/update-orders`, updAttributes).then(() => {
          this.attributes.forEach(function (attribute, index) {
            attribute.order = index + 1;
          });
          this.draging = false;
        }).catch(e => {
          Alert.toastError(e.response.data);
          this.draging = false;
        });
      }
    },
    clearAttrOptionStore() {
      this.attr_option_store =
          {
            option: '',
            require_compl: false,
            label: '',
          };
      this.editingStoreOption = false;
    },
    addStoreOption() {
      var option = JSON.stringify(this.attr_option_store);
      this.formStoreAttribute.options.push(JSON.parse(option));
      this.clearAttrOptionStore();
    },
    edtStoreOption(index) {
      var option = JSON.stringify(this.formStoreAttribute.options[index]);
      this.attr_option_store = JSON.parse(option);
      this.indexStoreOption = index;
      this.editingStoreOption = true;
      this.$refs.attrOptionsStoreOption.focus();
    },
    delStoreOption(index) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o atributo?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.formStoreAttribute.options.splice(index, 1);
          this.clearAttrOptionStore();
        }
      });
    },
    updStoreOption() {
      var option = JSON.stringify(this.attr_option_store);
      this.formStoreAttribute.options[this.indexStoreOption] = JSON.parse(option);
      this.clearAttrOptionStore();
    },
    clearAttrOptionEdit() {
      this.attr_option_edit =
          {
            option: '',
            require_compl: false,
            label: '',
          };
      this.editingEditOption = false;
    },
    addEditOption() {
      var option = JSON.stringify(this.attr_option_edit);
      this.formEditAttribute.options.push(JSON.parse(option));
      this.clearAttrOptionEdit();
    },
    edtEditOption(index) {
      var option = JSON.stringify(this.formEditAttribute.options[index]);
      this.attr_option_edit = JSON.parse(option);
      this.indexEditOption = index;
      this.editingEditOption = true;
      this.$refs.attrOptionsEditOption.focus();
    },
    delEditOption(index) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o atributo?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.formEditAttribute.options.splice(index, 1);
          this.clearAttrOptionEdit();
        }
      });
    },
    updEditOption() {
      var option = JSON.stringify(this.attr_option_edit);
      this.formEditAttribute.options[this.indexEditOption] = JSON.parse(option);
      this.clearAttrOptionEdit();
    },

  }
}
</script>

<style scoped>
.hover-row:hover {
  cursor: move;
}

.attr-default-text-editor :deep(.ql-editor) {
  min-height: 120px;
}
</style>